module.exports = __webpack_public_path__ + "img/10.6d862f62.jpg";